import React from "react";
var __jsx = React.createElement;
import autocompleteManager from "@lib/data/managers/shared/autocomplete-manager";
import MuscleAutocompleteInput from "@modules/shared/components/autocomplete-input";
import useErrorsManagement from "@lib/hooks/use-errors-management";
import Icons from "@modules/icons";
import APP_CONFIGURATION from "@lib/app.config";
const parseCarsLocationDataToAutocompleteOption = carsLocationData => {
  return {
    id: carsLocationData.iata,
    title: carsLocationData.value,
    value: carsLocationData
  };
};
const CarsLocationsAutocomplete = _ref => {
  let {
    className = "",
    name,
    value,
    hasErrors = false,
    errorMessage = "",
    onSelectOption,
    label,
    onBlur,
    placeholder,
    dataTestId,
    onClick,
    disablePopper = false,
    disableLabelAnimation = false,
    disableXButton = false,
    useBorderlessStyle = false
  } = _ref;
  const {
    manageOnlyAuthorizedError
  } = useErrorsManagement();
  const getLocationsByText = async text => {
    const data = await autocompleteManager.getCarsAutocompleteResults(text);
    if (Array.isArray(data) && data.length === 0) {
      return [];
    } else if (Array.isArray(data)) {
      return parseData(data);
    } else {
      var _code;
      manageOnlyAuthorizedError((_code = data === null || data === void 0 ? void 0 : data.code) !== null && _code !== void 0 ? _code : 'unknown');
      return [];
    }
  };
  const parseData = data => {
    const parsedData = data.map(parseCarsLocationDataToAutocompleteOption);
    return parsedData;
  };
  return __jsx(MuscleAutocompleteInput, {
    customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
    hasErrors: hasErrors,
    errorMessage: errorMessage,
    className: className,
    identifier: name + '-autocomplete',
    label: label !== null && label !== void 0 ? label : "",
    value: value && value.id !== "disabled" ? parseCarsLocationDataToAutocompleteOption(value) : undefined,
    onSelectOption: onSelectOption,
    getOptions: getLocationsByText,
    inputLabelIcon: __jsx(Icons.locationPin, {
      className: "text-primary_text",
      size: APP_CONFIGURATION.config.inputsIconSize
    }),
    onBlur: onBlur,
    placeholder: placeholder,
    dataTestId: dataTestId,
    onClick: onClick,
    disablePopper: disablePopper,
    disableLabelAnimation: disableLabelAnimation,
    disableXButton: disableXButton,
    useBorderlessStyle: useBorderlessStyle,
    optionsIcon: __jsx(Icons.locationPin, {
      className: "text-primary_text",
      size: 20
    })
  });
};
export default CarsLocationsAutocomplete;